import React from 'react';
import { FaithlifeButton, TwitterButton, FacebookButton } from 'react-social';
import xmlescape from 'xml-escape';
import { facebookAppId } from '../../data/sharing';
import { CopyToClipboardButton } from '../copy-to-clipboard-button';
import './index.less';

interface IShareButtonsProps {
	url?: string;
	title?: string;
	userRating?: number;
	embedUrl?: string;
}

interface IShareButtonsState {
	showingEmbed: boolean;
}

export class ShareButtons extends React.Component<IShareButtonsProps, IShareButtonsState> {
	private defaultUrl?: string;

	state: IShareButtonsState = {
		showingEmbed: false,
	};

	componentDidMount() {
		this.defaultUrl = document.location.toString();
	}

	_toggleShowingEmbed = () => {
		this.setState({ showingEmbed: !this.state.showingEmbed });
	};

	_highlight(e) {
		e.target.select();
	}

	render() {
		const { title, userRating, embedUrl } = this.props;
		const url = this.props.url || this.defaultUrl;
		const ratingText = userRating ? `I rated “${title}” ${userRating} stars ${'\u2b50'.repeat(userRating)}` : '';
		const embedCode = embedUrl
			? `<iframe src="${embedUrl}" width="640" height="360" frameborder="0" title="${xmlescape(
					title
			  )}" allowfullscreen></iframe>`
			: '';

		return (
			<div className="share-buttons">
				<FaithlifeButton className="button" url={url} content={ratingText}>
					<div className="faithlife-image" />
					<div className="info">Faithlife</div>
				</FaithlifeButton>
				<TwitterButton className="button" url={url}>
					<div className="twitter-image" />
					<div className="info">Twitter</div>
				</TwitterButton>
				<FacebookButton className="button" url={url} appId={facebookAppId}>
					<div className="facebook-image" />
					<div className="info">Facebook</div>
				</FacebookButton>
				{embedUrl ? (
					<button className="button" onClick={this._toggleShowingEmbed}>
						<EmbedIcon />
						<div className="info">Embed</div>
					</button>
				) : null}
				{this.state.showingEmbed ? (
					<div className="embed-container">
						{/* confirm change */}
						<textarea rows={3} value={embedCode} autoFocus onFocus={this._highlight} readOnly />
						<CopyToClipboardButton textToCopy={embedCode} />
					</div>
				) : null}
			</div>
		);
	}
}

const EmbedIcon = () => (
	<svg className="share-image" width="23" height="23" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
		<title>4CE185FC-41AA-49FE-9D25-D1A47C3CF689</title>
		<g fill="#bbb" fillRule="evenodd">
			<path d="M11.5819 24.2248 L6.5819 24.2248 L0.8585 12.5048 L6.5819 0.8368 L11.5819 0.8368 L5.8585 12.5048 L11.5819 24.2248 Z" />
			<path d="M24.1887 12.5308 L18.4913 24.2248 L13.4913 24.2248 L19.1887 12.5308 L13.4913 0.8368 L18.4913 0.8368 L24.1887 12.5308 Z" />
		</g>
	</svg>
);
